import { useRef, useCallback } from 'react';

export interface NavbarRef {
  scrollToSection: (id: string) => void;
}

interface NavbarProps {
  onNavigate?: (path: string) => void;
}

const Navbar = ({ onNavigate }: NavbarProps) => {
  const handleNavClick = useCallback((path: string) => {
    if (onNavigate) {
      onNavigate(path);
    } else {
      window.dispatchEvent(new CustomEvent('navigate', { detail: { path } }));
    }
  }, [onNavigate]);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-background-50/95 backdrop-blur-md border-b border-background-200/50" role="navigation" aria-label="主导航">
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <a href="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="被窝影院首页">
          <h1 className="text-xl md:text-2xl font-bold text-primary-500" style={{ fontFamily: 'var(--font-heading)' }}>
            被窝影院
          </h1>
        </a>

        <div className="hidden md:flex items-center gap-8">
          <a href="/" className="text-foreground-700 hover:text-primary-500 transition-colors text-sm font-medium whitespace-nowrap cursor-pointer">
            首页
          </a>
          <div className="relative group">
            <button className="text-foreground-700 hover:text-primary-500 transition-colors text-sm font-medium whitespace-nowrap cursor-pointer flex items-center gap-1">
              分类浏览
              <i className="ri-arrow-down-s-line text-xs"></i>
            </button>
            <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
              <div className="bg-background-100 border border-background-200/60 rounded-lg py-2 px-1 min-w-[140px] shadow-lg">
                {['国产剧', '美剧', '韩剧', '日剧', '动漫', '综艺', '纪录片'].map((cat) => (
                  <a
                    key={cat}
                    href={`/category/${encodeURIComponent(cat)}`}
                    className="block px-4 py-2 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-200/50 rounded-md transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat}
                  </a>
                ))}
              </div>
            </div>
          </div>
          <a href="/about" className="text-foreground-700 hover:text-primary-500 transition-colors text-sm font-medium whitespace-nowrap cursor-pointer">
            关于我们
          </a>
        </div>

        <div className="flex items-center gap-3">
          <div className="relative hidden sm:block">
            <input
              type="text"
              placeholder="搜索电视剧..."
              className="w-48 lg:w-56 h-9 pl-9 pr-3 rounded-full bg-background-100 border border-background-200/60 text-sm text-foreground-700 placeholder-foreground-500/60 focus:outline-none focus:border-primary-500/50 transition-colors"
              aria-label="搜索电视剧"
            />
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
          </div>
          <button className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer text-foreground-700" aria-label="菜单">
            <i className="ri-menu-line text-xl"></i>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;